import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from './IconBase';
const XIcon = _ref => {
  let {
    title = 'XIcon',
    ...rest
  } = _ref;
  return React.createElement(IconBase, _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, rest, {
    title: title
  }), React.createElement("path", {
    d: "M11.5221 8.77486L17.4784 2H16.0669L10.8951 7.8826L6.76436 2H2L8.24648 10.8955L2 18H3.41159L8.87328 11.7878L13.2356 18H18L11.5219 8.77486H11.5223H11.5221ZM9.58874 10.9737L8.95581 10.088L3.92012 3.03969H6.0881L10.1521 8.72789L10.785 9.61362L16.0676 17.0074H13.8996L9.58887 10.974V10.9736L9.58874 10.9737Z"
  }));
};
export default XIcon;
//# sourceMappingURL=XIcon.js.map